<template>
  <div class="part_con">
    <div class="side_warp">
      <ul class="list">
        <li
          v-for="(item, index) in sidePart"
          :key="index"
          :class="currentPart === index ? 'active' : ''"
          @click="changePart(index, item.nameA)"
        >
          <i class="el-icon-d-arrow-right"></i><span>{{ item.nameA }}</span>
        </li>
      </ul>
      <el-pagination
        background
        small
        :pager-count="5"
        :hide-on-single-page="true"
        @current-change="partSizeChange"
        :current-page="partPage"
        :page-size="partSize"
        layout="prev, pager, next"
        :total="partTotal"
      >
      </el-pagination>
    </div>
    <div class="main_box">
      <div class="top_label">
        <div class="item_title">
          {{ choicePart }}
        </div>
        <div class="select_box">
          <el-select
            v-model="selectVal"
            placeholder="年份"
            @change="changeSelect"
          >
            <el-option
              v-for="item in selectList"
              :key="item.id"
              :label="item.years"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="tableData.length > 0" class="main">
        <table class="content_table">
          <thead>
            <tr>
              <th class="th1">序号</th>
              <th class="th2">条目题名</th>
              <th>栏目名称</th>
              <th>年(卷)</th>
              <th>页码</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in tableData">
              <tr :key="index">
                <td class="td1">
                  {{ utils.getNewIndex(index, contentPage, contentSize) }}
                </td>
                <td
                  class="td2"
                  v-if="
                    (item.nameC === null || item.nameC === '') &&
                      (item.nameB === null || item.nameB === '')
                  "
                >
                  <div class="to_pdf" @click="toPdf(item.url)">
                    {{ item.nameA }}
                  </div>
                </td>
                <td
                  class="td2"
                  v-else-if="item.nameC === null || item.nameC === ''"
                >
                  <div class="to_pdf" @click="toPdf(item.url)">
                    {{ item.nameB }}
                  </div>
                </td>
                <td class="td2" v-else>
                  <div class="to_pdf" @click="toPdf(item.url)">
                    {{ item.nameC }}
                  </div>
                </td>
                <td class="td3">
                  <span>{{ item.nameA }}>>{{ item.nameB }}</span>
                </td>
                <td class="td4">
                  <span>{{ item.yearbooksFascicle.years }}</span>
                </td>
                <td class="td4">
                  <span>{{ item.pageNumber }}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <el-pagination
          background
          small
          :hide-on-single-page="true"
          @current-change="handleSizeChange"
          :current-page="contentPage"
          :page-size="contentSize"
          layout="total, prev, pager, next, jumper"
          :total="contentTotal"
        >
        </el-pagination>
      </div>
      <div v-else class="no_data">
        <img src="@/assets/img/common/no_data.svg" alt="" />
        <p>
          没有找到相关的内容
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentId: 0,
      currentPart: 0, //当前part下标
      choicePart: '', //当前选择栏目的标题
      partPage: 1, //左侧当前页数
      partSize: 30, //左侧每页显示多少条
      partTotal: null, //左侧当前页数
      contentPage: 1, //当前内容页数
      contentSize: 20, //每页显示多少条
      contentTotal: null, //总数
      selectList: [], //年份选择下拉框
      selectVal: '', //年份选中的值
      sidePart: [], //左侧栏目
      tableData: [] //列表内容
    }
  },
  mounted() {
    const { id } = this.$route.query
    this.currentId = Number(id)
    this.getSideTabs(id)
    this.getFascicleList(id)
  },
  methods: {
    // 栏目筛选
    changePart(i, value) {
      this.currentPart = i
      this.choicePart = value
      this.contentPage = 1
      this.getYearBooks()
    },
    // 加载左侧栏目数据
    async getSideTabs(id) {
      const res = await this.$http('/api/home/yearbooks/d/details', {
        params: {
          yearbooks: id,
          page: this.partPage - 1,
          size: this.partSize,
          sort: 'id'
        }
      })
      this.sidePart = res.content
      this.partTotal = res.totalElements
      this.choicePart = res.content[0].nameA
      this.getYearBooks()
    },
    // 加载列表数据
    async getYearBooks() {
      const res = await this.$http('/api/home/yearbooks/e/details', {
        params: {
          yearbooks: this.currentId,
          nameA: this.choicePart,
          yearbooksFascicle: this.selectVal
          // page: this.contentPage - 1,
          // size: this.contentSize,
        }
      })
      this.tableData = res.content
      this.contentTotal = res.totalElements
    },
    // 加载年份
    async getFascicleList(id) {
      const res = await this.$http('/api/home/yearbooks/fascicle/list', {
        params: {
          yearbooksId: id,
          size: 1000
        }
      })
      this.selectList = res.content
    },
    // 年份变化
    changeSelect() {
      this.getYearBooks()
    },
    // 左侧分页
    partSizeChange(page) {
      this.partPage = page
      this.currentPart = 0
      this.getSideTabs(this.currentId)
    },
    // 内容分页
    handleSizeChange(page) {
      this.contentPage = page
      this.getYearBooks(this.currentId)
    },
    // 跳转PDF
    toPdf(url) {
      window.open('/pdf/web/viewer.html?file=' + encodeURIComponent(url))
    }
  }
}
</script>

<style lang="less" scoped>
.part_con {
  display: flex;
  animation-duration: 0.4s;
}
.side_warp {
  width: 220px;
  padding-right: 10px;
  .list {
    padding-left: 20px;
    li {
      padding: 10px 0;
      border-bottom: 1px dashed #cccccc;
      cursor: pointer;
      display: flex;
      i {
        color: #999;
        margin-right: 4px;
      }
      span {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .active {
      color: @theme;
    }
  }
}
.main_box {
  flex: 1;
  padding-left: 20px;
  padding-right: 30px;
  .top_label {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #dfe3e8;
    padding: 0 30px;
    .item_title {
      font-weight: bold;
      font-size: 16px;
    }
    .select_box {
      // display: none;
      width: 130px;
      margin-right: 120px;
      /deep/.el-input__inner {
        height: 30px;
        border-radius: 0;
        background: #f2f6fa;
        border-color: #b3b3b3;
        &::-webkit-input-placeholder {
          color: #333;
        }
      }
      /deep/.el-select .el-input .el-select__caret {
        color: #666;
      }
      /deep/.el-input__suffix {
        display: flex;
        align-items: center;
      }
      /deep/.el-select .el-input.is-focus .el-input__inner {
        border-color: #333;
      }
    }
  }
}
.main {
  width: 100%;
  .content_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    tbody {
      tr {
        &:nth-child(2n + 1) {
          background: #dfe3e8;
        }
      }
    }
    span {
      display: inline-block;
    }
    th {
      height: 40px;
      font-size: 16px;
      font-weight: 600;
      box-sizing: border-box;
      text-align: left;
      color: #999;
      font-size: 14px;
    }
    td {
      height: 40px;
      color: #333333;
      font-size: 14px;
      box-sizing: border-box;
      // text-align: center;
      // padding: 0 10px;
      .to_pdf {
        cursor: pointer;
        color: #333333;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        &:hover {
          color: @theme;
          text-decoration: underline;
        }
      }
    }
    .th1 {
      text-align: center;
    }
    .th2 {
      padding-left: 10px;
    }
    .td1 {
      width: 60px;
      text-align: center;
    }
    .td2 {
      padding-left: 10px;
      padding-right: 30px;
    }
    .td3 {
      width: 160px;
      padding-right: 30px;
      span {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .td4 {
      width: 80px;
      span {
        width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.el-select-dropdown__item.selected {
  color: #333;
}
.el-select-dropdown__item {
  text-align: center;
}
</style>
